import React, { useContext } from 'react'
import { List } from 'Lib/List'
import SectionHeader from 'Lib/Text/SectionHeader'
import { ACCOUNT_HEADER } from 'AccountsConstants/language/account'
import AccountListItem from './AccountListItem'
import { AccountContext } from './context'
import SupportWidget from '../../components/Support/SupportWidget'

const Account = ({ loggedIn }) => {
  const { accountOpts } = useContext(AccountContext)
  const accountList = (
    <List className="amt-10">
      {accountOpts.map(opt => (
        <AccountListItem accountListInfo={opt} loggedIn={loggedIn} />
      ))}
    </List>
  )

  return (
    <React.Fragment>
      <SectionHeader marginTop="20">{ACCOUNT_HEADER}</SectionHeader>
      <div style={loggedIn ? { opacity: '1' } : { opacity: '0.7' }}>
        {accountList}
      </div>
      <SupportWidget verticalName="air" />
    </React.Fragment>
  )
}

export default Account
